import "./wdyr";
import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import mixpanel from "mixpanel-browser";
import { Provider } from "react-redux";
import { Auth0Provider } from "@auth0/auth0-react";
import { BrowserRouter } from "react-router-dom";
import { ErrorsInstrumentation, initializeFaro } from "@grafana/faro-react";
import { FontStyles, GlobalStyles, Toaster } from "@secuis/ccp-react-components";
import { store } from "./Store";
import App from "./App";
import SplashScreen from "./components/SplashScreen";
import "@secuis/ccp-react-components/dist/index.esm.css"; // load styles from SCL
import "./i18next";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
    api_host: "https://api-eu.mixpanel.com",
    debug: process.env.NODE_ENV === "development",
    persistence: "localStorage",
    track_pageview: false,
});

initializeFaro({
    url: process.env.REACT_APP_FARO_COLLECT_ENDPOINT,
    apiKey: process.env.REACT_APP_FARO_API_KEY,
    app: {
        name: process.env.REACT_APP_FARO_APP_NAME,
        environment: process.env.REACT_APP_FARO_ENVIRONMENT,
    },
    dedupe: false,
    instrumentations: [new ErrorsInstrumentation()],
});

ReactDOM.render(
    <Auth0Provider
        domain={process.env.REACT_APP_AUTH0_DOMAIN}
        audience={`https://${process.env.REACT_APP_AUTH0_DOMAIN}/userinfo`}
        clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
        redirectUri={window.location.origin}
        responseType="id_token"
        scope="openid profile email"
    >
        <Provider store={store}>
            <FontStyles />
            <GlobalStyles />
            <Suspense fallback={<SplashScreen />}>
                <BrowserRouter>
                    <Toaster>
                        <App />
                    </Toaster>
                </BrowserRouter>
            </Suspense>
        </Provider>
    </Auth0Provider>,
    document.getElementById("root")
);
